/**
 * Decode a vessel's flag state from its MMSI via the ITU Maritime Identification
 * Digits (MID) — the first three digits of the MMSI. This is a deterministic,
 * real lookup (no API). Covers the major flag states; unmapped MIDs return the
 * raw MID rather than a fabricated country. No regex.
 */

/** ITU MID → country/flag, for the common maritime flag states. */
const MID_COUNTRY: ReadonlyMap<number, string> = new Map([
  [201, 'Albania'], [205, 'Belgium'], [209, 'Cyprus'], [210, 'Cyprus'], [211, 'Germany'],
  [218, 'Germany'], [219, 'Denmark'], [220, 'Denmark'], [224, 'Spain'], [225, 'Spain'],
  [226, 'France'], [227, 'France'], [228, 'France'], [230, 'Finland'], [232, 'United Kingdom'],
  [233, 'United Kingdom'], [234, 'United Kingdom'], [235, 'United Kingdom'], [236, 'Gibraltar'],
  [237, 'Greece'], [238, 'Croatia'], [239, 'Greece'], [240, 'Greece'], [241, 'Greece'],
  [244, 'Netherlands'], [245, 'Netherlands'], [246, 'Netherlands'], [247, 'Italy'], [248, 'Malta'],
  [249, 'Malta'], [250, 'Ireland'], [253, 'Luxembourg'], [255, 'Madeira'], [256, 'Malta'],
  [257, 'Norway'], [258, 'Norway'], [259, 'Norway'], [261, 'Poland'], [263, 'Portugal'],
  [265, 'Sweden'], [266, 'Sweden'], [269, 'Switzerland'], [271, 'Turkey'], [272, 'Ukraine'],
  [273, 'Russia'], [275, 'Latvia'], [276, 'Estonia'], [277, 'Lithuania'], [304, 'Antigua & Barbuda'],
  [305, 'Antigua & Barbuda'], [308, 'Bahamas'], [309, 'Bahamas'], [311, 'Bahamas'], [312, 'Belize'],
  [314, 'Barbados'], [316, 'Canada'], [319, 'Cayman Islands'], [338, 'United States'], [351, 'Panama'],
  [352, 'Panama'], [353, 'Panama'], [354, 'Panama'], [355, 'Panama'], [356, 'Panama'], [357, 'Panama'],
  [366, 'United States'], [367, 'United States'], [368, 'United States'], [369, 'United States'],
  [370, 'Panama'], [371, 'Panama'], [372, 'Panama'], [373, 'Panama'], [374, 'Panama'], [375, 'St Vincent'],
  [376, 'St Vincent'], [377, 'St Vincent'], [412, 'China'], [413, 'China'], [414, 'China'], [416, 'Taiwan'],
  [419, 'India'], [422, 'Iran'], [431, 'Japan'], [432, 'Japan'], [440, 'South Korea'], [441, 'South Korea'],
  [445, 'North Korea'], [457, 'Mongolia'], [477, 'Hong Kong'], [525, 'Indonesia'], [533, 'Malaysia'],
  [538, 'Marshall Islands'], [548, 'Philippines'], [563, 'Singapore'], [564, 'Singapore'], [565, 'Singapore'],
  [566, 'Singapore'], [567, 'Thailand'], [574, 'Vietnam'], [577, 'Vanuatu'], [600, 'Egypt'], [605, 'Algeria'],
  [612, 'Côte d\'Ivoire'], [620, 'Comoros'], [636, 'Liberia'], [637, 'Liberia'], [657, 'Nigeria'],
  [664, 'Sudan'], [670, 'Togo'], [710, 'Brazil'], [720, 'Bolivia'], [725, 'Chile'], [730, 'Colombia'],
  [740, 'Falkland Islands'], [750, 'Ecuador'], [760, 'Peru'], [770, 'Uruguay'], [775, 'Venezuela'],
]);

/** Country/flag for an MMSI's MID, or the raw "MID nnn" when unmapped. */
export function flagForMmsi(mmsi: number): string {
  if (!Number.isFinite(mmsi) || mmsi <= 0) return '';
  const mid = Math.floor(mmsi / 1_000_000);
  return MID_COUNTRY.get(mid) ?? `MID ${mid}`;
}
